import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import React from 'react';
import {Trans, useTranslation} from 'react-i18next';
import {Depot} from '../../api/types';

interface RestartConfirmationDialogProps {
    open: boolean;
    depot: Depot;
    onConfirm: () => void;
    onCancel: () => void;
}

const RestartConfirmationDialog = (props: RestartConfirmationDialogProps) => {
    const { t } = useTranslation();

    return (
        <Dialog open={props.open}>
            <DialogTitle>
                {t('depot_details.restart_depot_warning.title', { depotId: props.depot.id })}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Trans
                        i18nKey={'depot_details.restart_depot_warning.text'}
                        values={{ depotId: props.depot.id, depotName: props.depot.name }}
                        components={{ strong: <strong /> } as any}
                    />
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onCancel}>
                    {t('common.cancel')}
                </Button>
                <Button color={'primary'} onClick={props.onConfirm} variant={'contained'}>
                    {t('depot_details.restart_depot_warning.restart')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RestartConfirmationDialog;
